module.exports = "data:image/svg+xml;base64,PHN2ZyBpZD0iUsOpdGVnXzEiIGRhdGEtbmFtZT0iUsOpdGVnIDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDMuOTYwNzIgMC43OTI4MyI+CiAgPGRlZnM+CiAgICA8c3R5bGU+CiAgICAgIC5jbHMtMSB7CiAgICAgICAgZmlsbDogI2VhMmY0YjsKICAgICAgfQogICAgPC9zdHlsZT4KICA8L2RlZnM+CiAgPHRpdGxlPnBvbnRvazwvdGl0bGU+CiAgPGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSIwLjM5NTgzIiBjeT0iMC4zOTY1MSIgcj0iMC4zOTU4MyIvPgogIDxjaXJjbGUgY2xhc3M9ImNscy0xIiBjeD0iMS45NzgxOSIgY3k9IjAuMzk3IiByPSIwLjM5NTgzIi8+CiAgPGNpcmNsZSBjbGFzcz0iY2xzLTEiIGN4PSIzLjU2NDg5IiBjeT0iMC4zOTU4MyIgcj0iMC4zOTU4MyIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/dots.svg
// module id = 492
// module chunks = 0